import React from "react";
import { Modal } from "react-bootstrap";



export default function AiSummaryModal({
  show,
  handleClose,
  title,
  summaryData
}) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold text-dark">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div style={{ whiteSpace: "pre-line", textAlign: "justify" }}>{summaryData}</div>
      </Modal.Body>
    </Modal>
  );
}
